export default __webpack_public_path__ + "static/designer-7a08bcae9ed5b8eafd46143f7ca0ea82.png";